import { MigrationInterface, QueryRunner } from 'typeorm'

export class AddVisibilityInMenu1695291885267 implements MigrationInterface {
	name = 'AddVisibilityInMenu1695291885267'

	public async up(queryRunner: QueryRunner): Promise<void> {
		await queryRunner.query(`ALTER TABLE "menu_item_category" RENAME COLUMN "visible" TO "isVisible"`)
		await queryRunner.query(`ALTER TABLE "category" ADD "isVisible" boolean NOT NULL DEFAULT true`)
	}

	public async down(queryRunner: QueryRunner): Promise<void> {
		await queryRunner.query(`ALTER TABLE "category" DROP COLUMN "isVisible"`)
		await queryRunner.query(`ALTER TABLE "menu_item_category" RENAME COLUMN "isVisible" TO "visible"`)
	}
}
